import React, {Component} from "react"
import styled from "styled-components"

import {FormattedMessage} from "@irati/utils/lang"
import {formatCurrency} from "@irati/utils/currency/formatCurrency"
import Price from "@irati/payments/types/PriceType"
import {Body} from "@irati/ui/src/Typography"
import {User} from "@irati/types"
import padding from "@irati/ui/src/global/padding"
import authentication from "@irati/auth"

const StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
`

const WrapperDiv = styled.div`
  width: 100%;
`

const Card = styled.div`
  border-radius: 3px;
  border: 1px solid ${({theme}) => theme.colors.greys.medium};
  margin-bottom: ${padding.tiny};
  padding: ${padding.tiny};
`

const LeftBody = styled(Body)`
  float: left;
`

interface Props {
  amount: number
  currency: string
  recipients: User[]
  wallet: Wallet
  updatedBalance: Price
}

class Totals extends Component<Props> {
  static defaultProps = {
    updatedRewardWalletBalance: undefined
  }
  render() {
    const {amount, currency, recipients, updatedBalance, wallet} = this.props
    if (recipients.length === 0) {
      return null
    }

    if (updatedBalance.amount < 0) {
      return (
        <Card>
          <FormattedMessage id="wallet.tenant.transfer.insufficient" />
        </Card>
      )
    }

    const tenantName = authentication.userTenant().public_name
    return (
      <Card>
        <StyledDiv>
          <WrapperDiv>
            <LeftBody small marginBottom={1}>
              <FormattedMessage id="wallet.tenant.transfer.wallet" values={{tenantName}} />
            </LeftBody>
            <Body small marginBottom={1} textAlign="right">
              <FormattedMessage
                id="wallet.tenant.transfer.available"
                values={{
                  total: formatCurrency({currencyCode: wallet.currency, value: wallet.availableBalance, isCents: false})
                }}
              />
            </Body>
            <Body small marginBottom={1} textAlign="right" weight="bold">
              <FormattedMessage
                id="wallet.tenant.transfer.minus"
                values={{
                  total: formatCurrency({currencyCode: currency, value: amount, isCents: false})
                }}
              />
            </Body>
            <Body small textAlign="right">
              <FormattedMessage
                id="wallet.tenant.transfer.remainder"
                values={{
                  total: formatCurrency({currencyCode: updatedBalance.currency, value: updatedBalance.amount, isCents: false})
                }}
              />
            </Body>
          </WrapperDiv>
        </StyledDiv>
      </Card>
    )
  }
}

export default Totals
